import { useVehicleContext } from "../VehicleContext";

function vinNewUsed(value) {
    if (value === "N") return "NEW";
    if (value === "U") return "USED";
    return value;
}

function VehicleTitle(props) {
    const context = useVehicleContext();

    let cviVehicle = context.cviSvsVehicle.data;
    let vaVehicle = context.vaCoreVehicle.data;
    let iolVehicle = context.iolVehicle.data;
    let ddcVehicle = context.ddcVehicle.data;
    let vinVehicle = context.vinVehicle.data;
    let mvsVehicle = context.vaMvsVehicle.data;

    if (!cviVehicle && !vaVehicle && !iolVehicle && !ddcVehicle && !vinVehicle && !mvsVehicle)
        return <div>Vehicle Details</div>;

    let vin = (cviVehicle?.dealerVehicle?.vin)
        ?? (vaVehicle?.vin)
        ?? (iolVehicle?.vin)
        ?? (ddcVehicle?.vin)
        ?? (vinVehicle?.core?.vin)
        ?? (mvsVehicle?.vehicleInformation?.vin);
    let newused = (cviVehicle?.inventoryVehicle?.inventoryType)
        ?? (vaVehicle?.newUsed)
        ?? (iolVehicle?.vehicleCondition)
        ?? (ddcVehicle?.type)
        ?? (vinVehicle?.core?.inventoryType && vinNewUsed(vinVehicle.core.inventoryType))
        ?? (mvsVehicle?.vehicleInformation?.inventoryType);
    let year = (cviVehicle?.dealerVehicle?.description?.year)
        ?? (vaVehicle?.modelYear)
        ?? (iolVehicle?.year)
        ?? (ddcVehicle?.year)
        ?? (vinVehicle?.core?.year)
        ?? (mvsVehicle?.vehicleInformation?.year);
    let make = (cviVehicle?.dealerVehicle?.description?.make)
        ?? (vaVehicle?.make)
        ?? (iolVehicle?.make)
        ?? (ddcVehicle?.make)
        ?? (vinVehicle?.core?.make)
        ?? (mvsVehicle?.vehicleInformation?.make);
    let model = (cviVehicle?.dealerVehicle?.description?.model?.normalizedName)
        ?? (vaVehicle?.model)
        ?? (iolVehicle?.model)
        ?? (ddcVehicle?.superModel)
        ?? (vinVehicle?.core?.model);

    return <div>
        {newused} {year} {make} {model} ({vin})
    </div>
}

export default VehicleTitle;